<div class="bg-m0 flex-grow select-none flex-col overflow-y-auto p-9">
  <div
    data-cy="addGivenDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Add Given</div
  >

  <form
    class="flex w-[700px] flex-col"
    [formGroup]="addGivenForm"
    (ngSubmit)="add()"
  >
    <div class="mt-9 flex flex-row items-start">
      <div class="mt-3 w-[120px] flex-shrink-0 text-base font-semibold"
        >Name</div
      >

      <div class="flex w-[400px] flex-col">
        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="addGivenDialogGivenIdInput"
          class="form-input border-s3 focus:border-m600 rounded"
          [ngClass]="{
            'border-r600':
              addGivenForm.controls['givenId'].invalid &&
              addGivenForm.controls['givenId'].touched
          }"
          formControlName="givenId"
        />
        <m-validation
          [control]="addGivenForm.controls['givenId']"
        ></m-validation>
      </div>
    </div>

    <div class="mt-2 flex flex-row items-center">
      <div class="w-[120px] flex-shrink-0 text-base font-semibold">Type</div>

      <div class="flex flex-col">
        <ng-select
          #addGivenDialogTypeSelect
          [fixNgSelectBottom]="addGivenDialogTypeSelect"
          data-cy="addGivenDialogTypeSelect"
          class="w-[180px] text-base"
          [items]="givenTypes"
          [clearable]="false"
          [searchable]="false"
          (keyup.esc)="
            $event.stopImmediatePropagation(); addGivenDialogTypeSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation(); addGivenDialogTypeSelect.blur()
          "
          appendTo="body"
          formControlName="type"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="ml-1 truncate">{{ item }}</div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 truncate">{{ item }}</div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="mt-8 flex flex-row items-center">
      <div class="w-[120px] flex-shrink-0 text-base font-semibold">Array</div>

      <div
        class="flex max-w-min cursor-pointer flex-row items-center"
        (click)="toggleIsMultiple()"
      >
        <ui-switch
          [checked]="addGivenForm.controls['isMultiple'].value === true"
          color="#64BD63"
        ></ui-switch>
      </div>
    </div>

    <div class="mt-8 flex min-h-[220px] flex-row items-start">
      <div class="mt-3 w-[120px] flex-shrink-0 text-base font-semibold">
        {{
          addGivenForm.controls['isMultiple'].value === true
            ? 'Values'
            : 'Value'
        }}
      </div>

      <div class="flex w-[400px] flex-col">
        <input
          *ngIf="addGivenForm.controls['isMultiple'].value !== true"
          autocomplete="off"
          spellcheck="false"
          data-cy="addGivenDialogValuesInput"
          class="form-input border-s3 focus:border-m600 rounded"
          [ngClass]="{
            'border-r600':
              addGivenForm.controls['values'].invalid &&
              addGivenForm.controls['values'].touched
          }"
          formControlName="values"
          placeholder="Value"
        />

        <textarea
          *ngIf="addGivenForm.controls['isMultiple'].value === true"
          autocomplete="off"
          spellcheck="false"
          data-cy="addGivenDialogValuesInput"
          class="form-textarea border-s3 focus:border-m600 h-48 resize-none rounded"
          [ngClass]="{
            'border-r600':
              addGivenForm.controls['values'].invalid &&
              addGivenForm.controls['values'].touched
          }"
          formControlName="values"
          placeholder="Values, one per line"
        ></textarea>
        <m-validation
          [control]="addGivenForm.controls['values']"
        ></m-validation>
      </div>
    </div>

    <div class="mt-6">
      <button
        data-cy="addGivenDialogAddButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Add</button
      >

      <button
        data-cy="addGivenDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
